<template>
  <div class="related-tags">
    <h1>Related Tags</h1>
    <div class="btns row">
      <div class="tech-btn" v-for="(tag, i) in tags" :key="i">
        {{ tag.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      buttons: ["Technology", "Spirtual", "Health"]
    };
  },
  props: ["tags"]
};
</script>

<style lang="scss" scoped>
.related-tags {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  /* margin-left: 140px; */
  margin-top: 32px;
  font-family: "Nunito", sans-serif;
  max-width: 835px;
  width: 100%;
}
.related-tags h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  color: #52595e;
}
.btns {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}
.btns .tech-btn {
  /* padding: 8px 0px 0px 24px; */
  /* max-width: 130px; */
  /* width: 100%; */
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 24px;
  text-align: center;
  color: #52595e;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  background-color: transparent;
  border: 1px solid #ddd;
  margin-right: 20px;
  padding: 8px 24px;
  transition: 0.3s linear;
  &:hover {
    box-shadow: 0 13px 27px 0 #f4f4f5;
    background-color: #f4f4f5;
    // color: #fff;
  }
}
@media (max-width: 500px) {
  .btns .tech-btn {
    margin-right: 0;
  }
}
@media (max-width: 400px) {
  .btns {
    margin-left: 10px;
  }
  .btns .tech-btn {
    padding: 8px 15px;
  }
  .related-tags h1 {
    margin-left: 10px;
  }
}
</style>
